import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=8c4d3f96&"
import script from "./PerPage.vue?vue&type=script&lang=js&"
export * from "./PerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports